import { TFunction } from '@lyearn/i18n';
import { CopyIcon, Trash2Outline } from '@lyearn/icons';
import { ActionMenuItemType } from '@lyearn/molecules';
import { QuestionFormActions } from '@/modules/corporate/modules/scorecards/views/ScorecardCreator/interfaces';

export const getActionMenuItems = (t: TFunction): ActionMenuItemType[] => [
  {
    label: t('Common:Actions.Duplicate'),
    appearance: 'primary',
    EndIcon: CopyIcon,
    id: QuestionFormActions.Duplicate,
  },
  {
    label: t('Common:Actions.Delete'),
    appearance: 'danger',
    EndIcon: Trash2Outline,
    id: QuestionFormActions.Delete,
  },
];
